import { required, minLength } from 'vuelidate/lib/validators'
const requiredMsg = 'Обязательное поле'

export default (vars) => {
  return {
    login: {
      required: {
        validator: required,
        message: requiredMsg
      }
    },
    password: {
      required: {
        validator: required,
        message: requiredMsg
      },
      minLength: {
        validator: minLength(vars.minPasswdLength),
        message: `Password must be at least ${vars.minPasswdLength} characters length`
      }
    }
  }
}
